import useFreeAmountDelivery from "hook/useFreeAmountDelivery";
import Marquee from "react-fast-marquee";
const Header = () => {
  const { freeAmountDeliveryData } = useFreeAmountDelivery();
  const freeDeliveryAmount = freeAmountDeliveryData?.[0]?.amount || 0;

  return (
    <div
      lang="bn"
      className=" flex justify-center items-center bg-[#265fc9] py-1 text-center"
    >
      <Marquee speed={50} pauseOnHover={true}>
        <p className=" text-sm text-white px-5 text-center">
          এখানে বাচ্চাদের প্রয়োজনীয় সামগ্রী ও কসমেটিকস পাওয়া যায় এবং পাইকারী ও
          খুচরা বিক্রয় করা হয়। আমাদের যে কোন পণ্য অর্ডার করতে কল বা WhatsApp
          করুনঃ 01971787661{" "}
        </p>
        {freeDeliveryAmount > 0 ? (
          <p className="flex items-center text-white mx-5">
            🎁🎁 {freeDeliveryAmount} টাকার পণ্য কিনলেই পাচ্ছেন সারা বাংলাদেশ
            ফ্রি ডেলিভারী অফার 🎁 🎁
          </p>
        ) : null}
      </Marquee>
    </div>
  );
};

export default Header;
